<template>
    <div class="gp-ci">
        <div class="gp-ci__container">
            <h4 class="gp-ci__title" v-text="$ml.get('titleViewGooglePay')" tabindex="0" />

            <GooglePayButton
                v-show="false"
                ref="gpButton"
            />

            <GooglePaySelectedCard
                :google-pay-selected-card-description="googlePaySelectedCardDescription"
                @buttonClicked="handleButtonClick"
            />

            <p class="gp-ci__select-title" v-text="$ml.get('installmentsExplanationV2')" tabindex="0" />
            <CieloSelectV2
                @change="selectItem"
                :title="$ml.get('installment')"
                name="selectInstallment"
                :label="$ml.get('installmentsNumber')"
                :option-items="installmentList || undefined"
                :selected-item="numberOfInstallments"
                :on-get-item-event="getLangOptions"
                :disabled="!paymentMethodImage || this.installmentIsFixed"
            />
        </div>

        <div class="gp-ci__cta-container">
            <ButtonsNextPreviousV2
                :disable-button-next="disableButtonNext"
                :back-text="'changePayment'"
                @click-next="goToNextStep"
                @click-previous="goToPreviousStep"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { Token, Options } from '@/config/lang/genericOptions.js';
    import { logEvent } from '@/helpers/cieloLogger';
    import ButtonsNextPreviousV2 from '@/components/template/ButtonsNextPreviousV2';
    import CieloSelectV2 from '@/components/ClickToPay/template/CieloSelectV2/CieloSelectV2';
    import GooglePaySelectedCard from '@/components/GooglePaySelectedCard';
    import GooglePayButton from '@/components/GooglePayButton';

export default {

    components: {
        ButtonsNextPreviousV2,
        CieloSelectV2,
        GooglePaySelectedCard,
        GooglePayButton,
    },

    data() {
        return {
            selectedCard: '',
            defaultBins: {
                AMEX: 377467,
                DISCOVER: 601102,
                JCB: 358292,
                VISA: 462294,
                MASTERCARD: 518600,
                ELO: 650505,
                // INTERAC: 0,
            }
        };
    },

    computed: {
        ...mapGetters({
            installmentList: 'payment/getInstallmentListForPaymentMethodSelected',
            selectedPaymentMethod: 'payment/getSelectedPaymentMethod',
            googlePaySelectedCard: 'googlePayPayment/getSelectedCard',
            googlePaySelectedCardDescription: 'googlePayPayment/getSelectedCardDescription',
            installmentIsFixed: 'payment/getSelectedPaymentMethodInstallmentIsAbleToBeFixed'
        }),

        numberOfInstallments: {
            get: (self) =>
                self.$store.getters['payment/getInstallmentNumberOfPayments'],
            set(value) {
                this.$store.commit('payment/setNumberOfInstallments', value);
            },
        },

        paymentMethodImage: (self) => {
            return self.selectedPaymentMethod ? self.selectedPaymentMethod.Image : null;
        },

        disableButtonNext() {
            if (!this.selectedCard || !this.numberOfInstallments) {
                return true;
            }

            return false;
        },
    },

    created() {
        this.selectedCard = this.googlePaySelectedCard;
        this.doBinQuery();
    },

    watch: {
        googlePaySelectedCard() {
            this.selectedCard = this.googlePaySelectedCard;
            this.doBinQuery();
        },
    },

    methods: {
        async doBinQuery() {
            try {
                await this.$store.dispatch('googlePayPayment/fetchCardBrand', this.defaultBins[this.selectedCard.info.cardNetwork]);

                return true;
            }
            catch (error) {
                logEvent({
                    category: 'BinQuery',
                    action: 'Do Bin Query',
                    label: `[BIN QUERY ERROR]: ${error}`
                });

                return false;
            }
        },

        goToNextStep() {
            logEvent({
                category: 'google_pay',
                action: 'parcelas_compra_gpay',
                label: 'Usuário escolhe a quantidade de parcelas.'
            });
            this.$store.dispatch('pipelineV2/pushTo', 'GooglePayBillingAddress');
        },

        goToPreviousStep() {

            logEvent({
                category: 'google_pay',
                action: 'troca_forma_pagamento_gpay',
                label: 'Na tela de escolha de parcela usuario escolhe trocar a forma de pagamento.'
            });
            this.$store.commit('payment/setNumberOfInstallments', 0);
            this.$store.commit('googlePayPayment/clearSelectedCard');
            this.$store.dispatch('pipelineV2/pushPrevious');
        },
        

        selectItem(item) {
            this.numberOfInstallments = item;
        },

        getLangOptions(item) {
            let tokens = [];

            tokens.push(new Token('quantity', item.Value));
            tokens.push(new Token('installmentPrice', item.installmentPrice));

            return new Options('installmentsItem', tokens);
        },

        handleButtonClick() {
            let element = this.$refs.gpButton.$el.querySelector('button');

            if(element) element.click();
        },
    },
};
</script>
<style lang='scss' scoped>
    .gp-ci {

      @media screen and (max-width: 1024px) {
          display: flex;
          flex-direction: column;
          flex: 1 0 auto;
      }

      &__container {
          margin-bottom: 32px;
          
          @media screen and (max-width: 1024px) {
              flex: 1;
          }
      }

      &__cta-container {}

      &__title {
          font-size: 16px;
          font-weight: 700;
          line-height: 11px;
          color: #2F363E;
          margin-bottom: 24px
      }

      &__select-title {
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 11px;
          color: #2F363E;
          margin-bottom: 20px;
      }

      .gp-selected-card {
          margin-bottom: 32px;
      }
    }
</style>
